import {DomainGraphType} from 'app-core/framework/CoreObjectConstants';
import {getApiBaseForObjectType} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {UpdateArchivableParams} from 'app-core/platform/archivable/CoreObjectArchiveConstants';
import {patchJSONPromise, postJSONPromise} from 'util/Net';

export interface CreateFileParams {
  name: string;
}

export interface CreateFileResponse {
  createdIds: Array<string>;
}

export function createFile(file: CreateFileParams): Promise<CreateFileResponse> {
  const creates = [file];
  return postJSONPromise({url: getApiBaseForObjectType(DomainGraphType.FILE), data: {creates}});
}

export interface UpdateFileParams extends UpdateArchivableParams {
  id: string;
  name?: string;
  folderId?: string;
  customFields?: {[name: string]: string};
}

export interface UpdateFileResponse {
  updatedIds: Array<string>;
}

export function updateFile(file: UpdateFileParams): Promise<UpdateFileResponse> {
  const updates = [file];
  return patchJSONPromise({url: getApiBaseForObjectType(DomainGraphType.FILE), data: {updates}});
}
